import React from 'react';

const Table2 = (props) => {
    return (
        <table border="0" cellSpacing="0" cellPadding="0" style={{
            width: "100%"
        }}>
            <tbody>
                <tr style={{
                    borderBottom: "2px solid black"
                }}>
                    <td colSpan={props.col ? props.col : '3'} style={{
                        fontWeight: "bold",
                        fontSize: "15px",
                        textAlign: "left",
                        paddingTop: "20px"
                    }}>
                        <span>{props.title}</span>&nbsp;
                        {props.subTitle ? (<span style={{
                            fontSize: "10px"
                        }}>{props.subTitle}</span>) : null}
                    </td>
                    <td></td>
                    <td></td>
                </tr>
                {props.children}
            </tbody>
        </table>
    )
};

export default React.memo(Table2);